export const mixinLists = {
	data: () => ({
		lists: {
			budget: [
				{
					value: 1,
					text: 'Операционный'
				},
				{
					value: 2,
					text: 'Капитальный'
				},
				{
					value: 3,
					text: 'Бюджет IFK'
				},
			],
			type: [
				{
					value: 1,
					text: 'Товар'
				},
				{
					value: 2,
					text: 'Услуга'
				},
				{
					value: 3,
					text: 'Заявка на наличные'
				},
				{
					value: 4,
					text: 'Выплата сотрудникам'
				},
				{
					value: 5,
					text: 'Мини-макс'
				}
			],
			urgent: [
				{
					value: 0,
					text: 'Обычный'
				},
				{
					value: 1,
					text: 'Срочный'
				},
			],
			deliveryBasis: [
				{
					value: 1,
					text: 'Склад покупателя'
				},
				{
					value: 2,
					text: 'Склад поставщика'
				},
			],
			dc: [],
			ic: [],
		}
	})
}
